











































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { updatePar, queryParById, updateContestant } from '@/api/player.ts'
import { UserModule } from '@/store/modules/user'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'addPromotionalImage',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private textarea: string = ''
  private value: string = ''
  private title = '设置标准杆';
  private title1 = '';
  private imageUrl: string = ''
  private actionType: string = 'add'
  private vueRest = '1'
  private index = 0
  private inputStyle = { flex: 1 }
  private titleId = ''
  private titleId1 = ''
  private addType = 0
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    id: '',
    contestant: 'ok',
    name: '',
    gender: '',
    country: '',
    type: '',
    isGroup: '',
    groupName: '',
    isOther: '',
    otherName: '',
    updateId: '',
    totalHole: 0,
    round: 0,
    team: 3,
    tee: 1,
    hold1: 0,
    hold2: 0,
    hold3: 0,
    hold4: 0,
    hold5: 0,
    hold6: 0,
    hold7: 0,
    hold8: 0,
    hold9: 0,
    hold10: 0,
    hold11: 0,
    hold12: 0,
    hold13: 0,
    hold14: 0,
    hold15: 0,
    hold16: 0,
    hold17: 0,
    hold18: 0,
  }

  get rules() {
    return {
      contestant: {
        required: true,
        message: '球场标准杆请填写完整'
      },
      team: {
        required: true,
        message: '团队赛名次不能为空'
      },
    }
  }

  created() {
    this.titleId1 = this.$route.query.titleId;
    if (this.$route.query.title) {
      this.title1 = this.$route.query.title
    }
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    this.init();
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  changeAddType(number: number) {
    if (number == 0) {
      document.getElementById('add')!.style.backgroundColor = "#ffc200"
      document.getElementById('reduce')!.style.backgroundColor = "#f0f0f0"
      this.addType = 0
    } else {
      document.getElementById('reduce')!.style.backgroundColor = "#ffc200"
      document.getElementById('add')!.style.backgroundColor = "#f0f0f0"
      this.addType = 1
    }
  }

  cancel() {
    this.$router.push({ path: '/competition/scoreRoundManage', query: { titleId: this.titleId1, title: this.title1 } })
  }

  // 判断是否有权限
  private hasPermission(): boolean {
    const roles = UserModule.username || [];
    if (roles.includes('admin')) return true;
    return false;
  }

  private async init() {
    queryParById(this.titleId).then(res => {
      if (res && res.data && res.data.code === 1) {
        console.log(res.data.data)
        this.ruleForm.team = res.data.data.sequence
        this.ruleForm.tee = res.data.data.tee
        this.ruleForm.updateId = res.data.data.id
        this.ruleForm.hold1 = res.data.data.hole1
        this.ruleForm.hold2 = res.data.data.hole2
        this.ruleForm.hold3 = res.data.data.hole3
        this.ruleForm.hold4 = res.data.data.hole4
        this.ruleForm.hold5 = res.data.data.hole5
        this.ruleForm.hold6 = res.data.data.hole6
        this.ruleForm.hold7 = res.data.data.hole7
        this.ruleForm.hold8 = res.data.data.hole8
        this.ruleForm.hold9 = res.data.data.hole9
        this.ruleForm.hold10 = res.data.data.hole10
        this.ruleForm.hold11 = res.data.data.hole11
        this.ruleForm.hold12 = res.data.data.hole12
        this.ruleForm.hold13 = res.data.data.hole13
        this.ruleForm.hold14 = res.data.data.hole14
        this.ruleForm.hold15 = res.data.data.hole15
        this.ruleForm.hold16 = res.data.data.hole16
        this.ruleForm.hold17 = res.data.data.hole17
        this.ruleForm.hold18 = res.data.data.hole18
        this.ruleForm.totalHole = res.data.data.hole1 + res.data.data.hole2 + res.data.data.hole3 + res.data.data.hole4 + res.data.data.hole5 + res.data.data.hole6 + res.data.data.hole7 + res.data.data.hole8 + res.data.data.hole9 + res.data.data.hole10 + res.data.data.hole11 + res.data.data.hole12 + res.data.data.hole13 + res.data.data.hole14 + res.data.data.hole15 + res.data.data.hole16 + res.data.data.hole17 + res.data.data.hole18
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  private submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        if (!this.ruleForm.team) return this.$message.error('团队赛名次不能为空')
        if (!this.ruleForm.hold1) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold2) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold3) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold4) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold5) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold6) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold7) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold8) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold9) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold10) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold11) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold12) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold13) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold14) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold15) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold16) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold17) return this.$message.error('球场标准杆请填写完整')
        if (!this.ruleForm.hold18) return this.$message.error('球场标准杆请填写完整')
        this.ruleForm.contestant = 'ok'
        if (!this.ruleForm.contestant) return this.$message.error('球场标准杆请填写完整')
        // let params: any = { ...this.ruleForm }
        let params: any = {}
        // params.flavors = this.dishFlavors
        params.titleId = this.ruleForm.titleId
        params.id = this.ruleForm.updateId
        params.sequence = this.ruleForm.team
        params.tee = this.ruleForm.tee
        params.hole1 = this.ruleForm.hold1
        params.hole2 = this.ruleForm.hold2
        params.hole3 = this.ruleForm.hold3
        params.hole4 = this.ruleForm.hold4
        params.hole5 = this.ruleForm.hold5
        params.hole6 = this.ruleForm.hold6
        params.hole7 = this.ruleForm.hold7
        params.hole8 = this.ruleForm.hold8
        params.hole9 = this.ruleForm.hold9
        params.hole10 = this.ruleForm.hold10
        params.hole11 = this.ruleForm.hold11
        params.hole12 = this.ruleForm.hold12
        params.hole13 = this.ruleForm.hold13
        params.hole14 = this.ruleForm.hold14
        params.hole15 = this.ruleForm.hold15
        params.hole16 = this.ruleForm.hold16
        params.hole17 = this.ruleForm.hold17
        params.hole18 = this.ruleForm.hold18
        params.type = 0
        // params.type = 1
        // params.price *= 100
        if (this.actionType == 'add') {
          params.titleId = this.titleId
          delete params.id
          updatePar(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('标准杆设置成功！')
                  this.$router.push({ path: '/competition/scoreRoundManage', query: { titleId: this.titleId1, title: this.title1 } })
              } else {
                this.$message.error(res.data.data || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          params.id = this.ruleForm.id
          params.titleId = this.titleId
          updateContestant(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$router.push({ path: '/competition/scoreRoundManage', query: { titleId: this.titleId1, title: this.title1 } })
                this.$message.success('标准杆设置成功！')
              } else {
                this.$message.error(res.data.data || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('菜品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.photo = value
  }
}
